import Vue from 'vue'
import VueGtm from 'vue-gtm'

import { currentSite } from '@/extend'
import CONST from '@/const/shared'

export const initVueGtm = country => {
  if (!CONST.siteData[currentSite()].countries[country]) return

  Vue.use(VueGtm, {
    id: CONST.siteData[currentSite()].countries[country].googleAnalyticsId,
    queryParams: {
      // Add url query string when load gtm.js with GTM ID (optional)
      gtm_auth: process.env.VUE_APP_GTM_AUTH,
      gtm_preview: process.env.VUE_APP_GTM_PREVIEW,
      gtm_cookies_win: process.env.VUE_APP_GTM_COOKIES_WIN
    },
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    // vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    ignoredViews: [] // If router, you can exclude some routes name (case insensitive) (optional)
  })
}
